import { AuthenticateModel, AuthenticateResultModel, TokenAuthServiceProxy } from 'src/shared/service-proxies/service-proxies';
import { Router, NavigationExtras } from '@angular/router';
import { finalize } from 'rxjs/operators';
import { UrlHelper } from 'src/shared/helpers/UrlHelper';
import { AppConsts } from 'src/shared/AppConsts';
import { LogService } from '@shared/log/log.service';
import { Injectable } from '@angular/core';
import { MessageService } from '@shared/message/message.service';
import { AppSessionService } from '@shared/session/app-session.service';
import { AppStorageService } from '@shared/storage/app-storage.service';
import { Platform, LoadingController, AlertController } from '@ionic/angular';

@Injectable({
    providedIn: 'root'
})
export class LoginService {

    static readonly twoFactorRememberClientTokenName = 'TwoFactorRememberClientToken';

    authenticateModel: AuthenticateModel;
    authenticateResult: AuthenticateResultModel;

    rememberMe: boolean;

    postLoginPage = '/main/home';

    constructor(
        private _tokenAuthService: TokenAuthServiceProxy,
        private _router: Router,
        private _messageService: MessageService,
        private _logService: LogService,
        private _appSessionService: AppSessionService,
        private _appStorageService: AppStorageService,
        private _platform: Platform,
        private loadingController: LoadingController,
        private alertController: AlertController
    ) {
        this.clear();
    }

    async authenticate(finallyCallback?: () => void): Promise<void> {
        finallyCallback = finallyCallback || (() => { });
    
        const loading = await this.loadingController.create({
          message: 'Authenticating user...',
        });
        await loading.present();

        this._tokenAuthService
            .authenticate(this.authenticateModel)
            .pipe(finalize(() => { finallyCallback(); }))
            .subscribe(
                async (result: AuthenticateResultModel) => {
                    this.processAuthenticateResult(result);
                    await loading.dismiss();
                },
                async (error) => {
                    await loading.dismiss();

                    const alert = await this.alertController.create({
                      header: 'Error',
                      message: 'Login Failed',
                      buttons: ['OK']
                    });
                    await alert.present();
                }
            );
    }

    private processAuthenticateResult(authenticateResult: AuthenticateResultModel) {
        this.authenticateResult = authenticateResult;

        if (authenticateResult.accessToken) {
            // Successfully logged in
            this.login(
                authenticateResult.accessToken,
                authenticateResult.encryptedAccessToken,
                authenticateResult.expireInSeconds,
                this.rememberMe);

        } else {
            // Unexpected result!

            this._logService.warn('Unexpected authenticateResult!');
            this._router.navigate(['account/login']);
        }
    }

    private login(accessToken: string, encryptedAccessToken: string, expireInSeconds: number, rememberMe?: boolean): void {

        const tokenExpireDate = rememberMe ? (new Date(new Date().getTime() + 1000 * expireInSeconds)) : undefined;

        this._appStorageService.setToken(accessToken,
            encryptedAccessToken,
            tokenExpireDate)

            this._appSessionService.init().then(() => {
            let initialUrl = UrlHelper.initialUrl;
            if (initialUrl.indexOf('/login') > 0) {
                initialUrl = AppConsts.appBaseUrl;
            }
            initialUrl = UrlHelper.striphost(location);
            // if (this._platform.is('cordova')) {
            //     const navigationExtras: NavigationExtras = {
            //       queryParams: {
            //         farmerId: null // we need to fetch users farmerId....
            //       }
            //     };
            //     this._router.navigate(['/account/profile'], navigationExtras); // this is actually the farmer profile page...
            // } else {
                this._router.navigate([this.postLoginPage]); // User Dashboard (Admin and Data Collector)
            // }
        })

    }

    private clear(): void {
        this.authenticateModel = new AuthenticateModel();
        this.authenticateModel.rememberClient = false;
        this.authenticateResult = null;
        this.rememberMe = false;
    }
}
